// EU delivery countries (codes the storefront may receive from /api/tax-rates),
// with display names per language.
export const EU_COUNTRY_NAMES: Record<string, { de: string; en: string }> = {
  DE: { de: 'Deutschland', en: 'Germany' },
  AT: { de: 'Österreich', en: 'Austria' },
  BE: { de: 'Belgien', en: 'Belgium' },
  BG: { de: 'Bulgarien', en: 'Bulgaria' },
  HR: { de: 'Kroatien', en: 'Croatia' },
  CY: { de: 'Zypern', en: 'Cyprus' },
  CZ: { de: 'Tschechien', en: 'Czechia' },
  DK: { de: 'Dänemark', en: 'Denmark' },
  EE: { de: 'Estland', en: 'Estonia' },
  FI: { de: 'Finnland', en: 'Finland' },
  FR: { de: 'Frankreich', en: 'France' },
  GR: { de: 'Griechenland', en: 'Greece' },
  HU: { de: 'Ungarn', en: 'Hungary' },
  IE: { de: 'Irland', en: 'Ireland' },
  IT: { de: 'Italien', en: 'Italy' },
  LV: { de: 'Lettland', en: 'Latvia' },
  LT: { de: 'Litauen', en: 'Lithuania' },
  LU: { de: 'Luxemburg', en: 'Luxembourg' },
  MT: { de: 'Malta', en: 'Malta' },
  NL: { de: 'Niederlande', en: 'Netherlands' },
  PL: { de: 'Polen', en: 'Poland' },
  PT: { de: 'Portugal', en: 'Portugal' },
  RO: { de: 'Rumänien', en: 'Romania' },
  SK: { de: 'Slowakei', en: 'Slovakia' },
  SI: { de: 'Slowenien', en: 'Slovenia' },
  ES: { de: 'Spanien', en: 'Spain' },
  SE: { de: 'Schweden', en: 'Sweden' },
};

export const NON_EU_CODE = 'NON_EU';

export const countryName = (code: string, lang: string): string => {
  const upper = code?.toUpperCase();
  if (upper === NON_EU_CODE) return lang?.startsWith('en') ? 'Non-EU / Other (export)' : 'Nicht-EU / Andere (Ausfuhr)';
  const entry = EU_COUNTRY_NAMES[upper];
  if (!entry) return code;
  return lang?.startsWith('en') ? entry.en : entry.de;
};

/**
 * A delivery country is an export (net price, no VAT charged here) when it is
 * the synthetic NON_EU option or when it is not one of the maintained countries
 * returned by /api/tax-rates. Germany and maintained countries are never export.
 */
export const isExportCountry = (
  code: string | undefined | null,
  maintainedCodes: string[],
): boolean => {
  const upper = (code || '').toUpperCase();
  if (!upper) return false;
  if (upper === NON_EU_CODE) return true;
  return !maintainedCodes.map((c) => c.toUpperCase()).includes(upper);
};
